import React from 'react'
import Fragment from '../common/fragment'


function FragmentAE(props) {
  return (
    <Fragment pos="e" {...props}>
      <p>
      Un valle inquietante es un lugar donde los humanos conviven con los robots y los
      muertos. “El principio sostiene que la respuesta emocional de un humano hacia una
      entidad en apariencia y funcionamiento muy cercana se incrementa positivamente y
      de forma empática hasta alcanzar un punto en el que la respuesta emocional se
      vuelve fuertemente repulsiva” (Mori). No soportamos lo que se nos parece y las
      máquinas han sido expulsadas del Paraíso. Eso lo saben los evangélicos que
      predican al caer la tarde en Salamanca. Les enrostran a las chimeneas de la refinería
      su orgullo y la fortaleza de sus materiales. Les advierten que no tendrán lugar en los
      otros valles, prometidos y lejanos, donde nos aguarda una felicidad desconocida.
      </p>
    </Fragment>
  )
}


export default FragmentAE
